var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompactList',{attrs:{"items":_vm.items || []},scopedSlots:_vm._u([{key:"listItem",fn:function(ref){
var item = ref.item;
return [_c('NameTranslationOutput',{attrs:{"name":item.name.replace(/\s/g, '_'),"namespace":"common.entity.offer.categoriesTypes"}})]}},{key:"tooltipItem",fn:function(ref){
var item = ref.item;
return [_c('NameTranslationOutput',{attrs:{"name":item.name.replace(/\s/g, '_'),"namespace":"common.entity.offer.categoriesTypes"}})]}},{key:"singleItem",fn:function(ref){
var item = ref.item;
return [_c('NameTranslationOutput',{attrs:{"name":item.name.replace(/\s/g, '_'),"namespace":"common.entity.offer.categoriesTypes"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }